import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

import { TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";

import { DesktopSideBarComponent } from "../../components/side-bar/side-bar.component";
import { DesktopDashboardComponent } from "../../pages/dashboard/dashboard.component";
import { ActionButtonComponent } from "../../components/ui-components/buttons/action-button/action-button.component";
import { CardButtonSize } from "../../components/ui-components/buttons/card-button/card-button.model";
import { ActionButtonType } from "../../components/ui-components/buttons/action-button/action-button.model";

@Component({
  selector: "app-desktop-layout",
  templateUrl: "./desktop-layout.component.html",
  styleUrls: ["./desktop-layout.component.scss"],
  imports: [
    DesktopSideBarComponent,
    DesktopDashboardComponent,
    RouterOutlet,
    ActionButtonComponent,
    TranslateModule,
    NgxSpinnerModule,
  ],
  standalone: true,
})
export class DesktopLayoutComponent {
  ActionButtonType = ActionButtonType;
  CardButtonSize = CardButtonSize;
  constructor() {}

  ngOnInit(): void {}

  disableContextMenu($event: MouseEvent) {
    /* $event.preventDefault();
    alert("Není povoleno používat kontextové menu na této stránce."); */
  }
}
